import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  content: {
    padding: "2em 3em !important",
    color: theme.colors.offWhite,
  },
  box: {
    marginBottom: theme.spacing(3),
  },
  link: {
    color: theme.colors.black,
    "&:hover": {
      fontWeight: "bold",
    },
    "&:active": {
      color: theme.colors.offWhite,
    },
  },
}));

export default useStyles;
// https://startpages.github.io/startpages/startpage-tudurom/
